import merchantServicePackagesSliceReducer from './merchantServicePackagesSlice'

export default merchantServicePackagesSliceReducer;